"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.usePriceProps = void 0;
const common_components_1 = require("@as-react/common-components");
const usePriceViewModel_1 = require("./usePriceViewModel");
const usePriceDiscountTag_1 = require("./usePriceDiscountTag");
const usePriceProps = ({ priceInformation, dynamicSavingsInformation, enablePriceReference, fallbackPriceViewModel, }) => {
    var _a;
    const { currency } = (0, common_components_1.useAemConfig)();
    const priceViewModel = (0, usePriceViewModel_1.usePriceViewModel)({
        prices: priceInformation === null || priceInformation === void 0 ? void 0 : priceInformation.prices,
        hasDiscount: Boolean(priceInformation === null || priceInformation === void 0 ? void 0 : priceInformation.hasDiscount),
    }, fallbackPriceViewModel, enablePriceReference);
    const tag = (0, usePriceDiscountTag_1.usePriceDiscountTag)(priceInformation, dynamicSavingsInformation, enablePriceReference);
    if (!((_a = priceInformation === null || priceInformation === void 0 ? void 0 : priceInformation.prices) === null || _a === void 0 ? void 0 : _a.SELL))
        return null;
    return Object.assign(Object.assign({ currency }, priceViewModel), { tag });
};
exports.usePriceProps = usePriceProps;
